<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputPercentage" });
import { InputNumber } from "../index.js";
import { percentage as format } from "../../common/format.js";
export let value;
export let name;
export let label = void 0;
export let placeholder = void 0;
export let hint = void 0;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
export let minimum = 0;
export let maximum = 100;
export let step = 0.01;
export let mode = "integer";
const getHint = (hint2, minimum2, maximum2) => {
    const HAS_MINIMUM = minimum2 !== void 0 && minimum2 !== 0;
    const HAS_MAXIMUM = maximum2 !== void 0 && maximum2 !== 100;
    if (hint2 !== void 0) {
        return hint2;
    }
    if (HAS_MINIMUM && HAS_MAXIMUM) {
        return `between ${format(minimum2 / 100)} and ${format(maximum2 / 100)}`;
    }
    if (HAS_MINIMUM) {
        return `Minimum: ${format(minimum2 / 100)}`;
    }
    if (HAS_MAXIMUM) {
        return `Maximum: ${format(maximum2 / 100)}`;
    }
    return null;
};
const decimalPlaces = (number) => {
    if (Number.isInteger(number)) {
        return 0;
    }
    const PARTS = number.toString().split(".");
    if (PARTS.length === 2) {
        return PARTS[1].length;
    }
    return 0;
};
$: numberOfDecimalPlaces = step === void 0 ? 0 : decimalPlaces(step);
const handlePercentageChange = (percentage2) => {
    if (percentage2 === void 0) {
        value = void 0;
        return;
    }
    value = parseFloat((percentage2 / 100).toFixed(numberOfDecimalPlaces + 2));
};
$: defaultHint = getHint(hint, minimum, maximum);
$: percentage = value === void 0 ? void 0 : parseFloat((value * 100).toFixed(numberOfDecimalPlaces));
$: handlePercentageChange(percentage);
</script>

<InputNumber
    bind:value = { percentage }
    hint = { defaultHint }
    { minimum }
    { maximum }
    { step }
    { mode }
    { label }
    { name }
    { isDisabled }
    { isReadonly }
    { isRequired }
    { placeholder }
    type = 'text'
    dimension = '%'
/>